__turbopack_context__.v({
  "className": "public_sans_9b93f413-module__j5-roG__className",
});
